import React, { useState, useEffect } from 'react';
import Helmet from 'react-helmet';
import { Link, useNavigate } from 'react-router-dom';
import { functions } from '../../Firebase';

const OPEN_STATUSES = ['open', 'in_progress'];
const CLOSED_STATUSES = ['resolved', 'closed'];

export default function TicketList(props) {
  const navigate = useNavigate();
  const [ticketType, setTicketType] = useState(true);
  const [ticketData, setTicketData] = useState([]);
  const [loading, setLoading] = useState(true);

  const user = props.user;

  useEffect(() => {
    if (!user || !user.uid) {
      setTicketData([]);
      setLoading(false);
      return;
    }

    setLoading(true);
    const getUserSupportTickets = functions.httpsCallable("getUserSupportTickets");

    getUserSupportTickets()
      .then((result) => {
        const allTickets = result.data.tickets || [];
        const statuses = ticketType ? OPEN_STATUSES : CLOSED_STATUSES;
        const filtered = allTickets
          .filter((t) => statuses.includes(t.status))
          .sort((a, b) => {
            const aTime = a.updatedAt?._seconds ?? a.updatedAt?.seconds ?? a.createdAt?._seconds ?? a.createdAt?.seconds ?? 0;
            const bTime = b.updatedAt?._seconds ?? b.updatedAt?.seconds ?? b.createdAt?._seconds ?? b.createdAt?.seconds ?? 0;
            return bTime - aTime;
          });
        setTicketData(filtered);
      })
      .catch((error) => {
        console.error("Error fetching tickets:", error);
        setTicketData([]);
      })
      .finally(() => {
        setLoading(false);
      });
  }, [ticketType, user?.uid]);

  const formatDate = (ts) => {
    if (!ts) return 'No date';
    const date = ts.toDate ? ts.toDate() : ((ts._seconds ?? ts.seconds) ? new Date((ts._seconds ?? ts.seconds) * 1000) : null);
    return date ? date.toLocaleString("en-NZ") : 'No date';
  };

  const getLastMessageDate = (ticket) => {
    const responses = ticket.responses || [];
    if (responses.length > 0) {
      const last = responses[responses.length - 1];
      return last.createdAt || ticket.updatedAt || ticket.createdAt;
    }
    return ticket.updatedAt || ticket.createdAt;
  };

  const isClosed = !ticketType;
  const colCount = isClosed ? 6 : 4;

  return (
    <div className="home">
      <Helmet>
        <title>Trippie Air - Support</title>
        <meta name="description" content="Trippie Air" />
      </Helmet>
      <div className="home-hero bg-gradient">
        <div className="container-middle-content">
          <div className="tickets-header-text">
            <h1 className="medium-heading">Support Tickets List</h1>
            <Link to="/support/create-ticket" className="standard-button invert-btn-color">
              New Ticket
            </Link>
          </div>
        </div>
      </div>
      <div className="bg-gradient">
        <div className="container-middle-content">
          <div className="switch-buttons-container">
            <button
              className={ticketType ? "switch-buttons terms-buttons active fw-600" : "switch-buttons terms-buttons fw-600"}
              onClick={() => setTicketType(true)}
            >
              Open Tickets
            </button>
            <button
              className={!ticketType ? "switch-buttons terms-buttons active fw-600" : "switch-buttons terms-buttons fw-600"}
              onClick={() => setTicketType(false)}
            >
              Closed Tickets
            </button>
          </div>
        </div>
      </div>
      <div className="container-middle-content support-ticket-section">
        <div className={`support-ticket-list ${isClosed ? 'support-ticket-list-closed' : ''}`}>
          <h1 className="small-heading">List of all your {ticketType ? "open" : "closed"} tickets</h1>
          <div className="support-ticket-table-wrap">
            <table className="support-ticket-table">
              <thead>
                <tr>
                  <th>Ticket Number</th>
                  <th>Reason</th>
                  <th>Date of Submission</th>
                  <th>Last Message</th>
                  {isClosed && (
                    <>
                      <th>Closed By</th>
                      <th>Closing Date</th>
                    </>
                  )}
                </tr>
              </thead>
              <tbody>
                {loading ? (
                  <tr>
                    <td colSpan={colCount} className="support-ticket-cell-message">Loading...</td>
                  </tr>
                ) : ticketData.length > 0 ? (
                  ticketData.map((ticket) => (
                    <tr
                      key={ticket.id}
                      className="support-ticket-row"
                      onClick={() => navigate(`/support/ticket/${ticket.id}`)}
                      role="button"
                      tabIndex={0}
                      onKeyDown={(e) => {
                        if (e.key === 'Enter' || e.key === ' ') {
                          e.preventDefault();
                          navigate(`/support/ticket/${ticket.id}`);
                        }
                      }}
                    >
                      <td>
                        <Link to={`/support/ticket/${ticket.id}`} className="support-ticket-id-link" onClick={(e) => e.stopPropagation()}>
                          #{ticket.id?.slice(-8) || ticket.id}
                        </Link>
                      </td>
                      <td>{ticket.reason || 'No reason provided'}</td>
                      <td>{formatDate(ticket.createdAt)}</td>
                      <td>{formatDate(getLastMessageDate(ticket))}</td>
                      {isClosed && (
                        <>
                          <td>{ticket.closedByName || ticket.closedBy || '—'}</td>
                          <td>{formatDate(ticket.closedAt)}</td>
                        </>
                      )}
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan={colCount} className="support-ticket-cell-message">
                      You do not have any {ticketType ? "open" : "closed"} tickets
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
}
